/**
 * Do not edit directly
 */

export default "PHN2ZyBpZD0iZXZlbnQiIGRhdGEtbmFtZT0iZXZlbnQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNNi41OCwxNWwuNzctNS4zMUgxLjIzTDkuMjcsMSw4LjUsNi4yOGw2LDBaTTguNSw4LjY1LDgsMTEuODhsNC4yMi00LjYyLTQuOTEsMEw3LjgyLDQsMy41Miw4LjY2WiIvPjwvc3ZnPg==";